"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/purchasehistory/v1/legacy_portal_service.proto (package spwn.purchasehistory.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse = exports.LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest = exports.LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse = exports.LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const legacy_portal_common_pb_1 = require("./legacy_portal_common_pb");
/**
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest
 */
class LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest, a, b);
    }
}
exports.LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest = LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest;
LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest.runtime = protobuf_1.proto3;
LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest";
LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "created_at_from", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "created_at_to", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "utc_offset_minutes", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse
 */
class LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 注文一覧（注文日時の降順）
         *
         * @generated from field: repeated spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrder orders = 1;
         */
        this.orders = [];
        /**
         * 次ページのカーソル。空文字なら次ページなし。値は不透明でクライアントは解釈しない
         *
         * @generated from field: string next_cursor = 2;
         */
        this.nextCursor = "";
        /**
         * 購入履歴がある年と件数（絞り込み前の全期間、年の降順）
         *
         * @generated from field: repeated spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryAvailableYear available_years = 3;
         */
        this.availableYears = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse, a, b);
    }
}
exports.LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse = LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse;
LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse.runtime = protobuf_1.proto3;
LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse";
LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "orders", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalPurchaseHistoryOrder, repeated: true },
    { no: 2, name: "next_cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "available_years", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalPurchaseHistoryAvailableYear, repeated: true },
]);
/**
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest
 */
class LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 注文ID。SPWNはFirestoreのdocument ID、Shopifyは注文時点の注文名。取得元はこの値から判定する
         *
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest, a, b);
    }
}
exports.LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest = LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest;
LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest.runtime = protobuf_1.proto3;
LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest";
LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse
 */
class LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse, a, b);
    }
}
exports.LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse = LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse;
LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse.runtime = protobuf_1.proto3;
LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse";
LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalPurchaseHistoryOrder },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map